import { Helper } from '../../Helper';
export class GetBufferIndexHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.unwrapBuffer);
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'SIZE');
        sb.emitOp(node, 'OVER');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'GT');
            },
            whenTrue: () => {
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'SIZE');
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'SUB');
                sb.emitOp(node, 'RIGHT');
                sb.emitPushInt(node, 1);
                sb.emitOp(node, 'LEFT');
                sb.emitHelper(node, options, sb.helpers.wrapNumber);
            },
            whenFalse: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitHelper(node, options, sb.helpers.wrapUndefined);
            },
        }));
    }
}

//# sourceMappingURL=GetBufferIndexHelper.js.map
